import { useState, type FormEvent } from 'react'
import { api } from './api'
import PasswordField from './PasswordField'

export default function AdminAccount() {
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const [done, setDone] = useState(false)

  async function onSubmit(event: FormEvent) {
    event.preventDefault()
    setError('')
    setDone(false)
    if (next !== confirm) {
      setError("The new passwords don't match.")
      return
    }
    setBusy(true)
    try {
      await api('/api/admin/account/password', {
        method: 'POST',
        body: JSON.stringify({ currentPassword: current, newPassword: next }),
      })
      setCurrent('')
      setNext('')
      setConfirm('')
      setDone(true)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not change your password.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <section>
      <p className="text-caps text-[10px] text-rose">You</p>
      <h2 className="mt-1 font-serif text-[32px] leading-none font-medium">Account</h2>
      <form onSubmit={(event) => void onSubmit(event)} className="mt-8 flex max-w-[460px] flex-col gap-5">
        <h3 className="text-caps text-[11px] text-muted">Change your password</h3>
        {error ? <p className="text-sm text-rose">{error}</p> : null}
        {done ? (
          <p className="text-sm text-ink">Password changed. You're still signed in here; other devices were signed out.</p>
        ) : null}
        <PasswordField label="Current password" value={current} onChange={setCurrent} autoComplete="current-password" />
        <PasswordField
          label="New password"
          value={next}
          onChange={setNext}
          generate
          onGenerated={setConfirm}
        />
        <PasswordField label="Confirm new password" value={confirm} onChange={setConfirm} />
        <p className="-mt-2 text-[12px] text-muted">At least 10 characters.</p>
        <button type="submit" disabled={busy} className="text-caps h-11 bg-ink text-white hover:bg-rose disabled:opacity-60">
          {busy ? 'Saving…' : 'Change password'}
        </button>
      </form>
    </section>
  )
}
